export default __webpack_public_path__ + "static/media/icon-info-line.70397b0f.svg";